@if (guideService.active(); as active) {
  @let step = shown()?.step ?? guideService.step()!;
  @let index = shown()?.index ?? active.index;
  @if (mode() === 'spotlight' && spotlight(); as box) {
    <div class="guide__spotlight" aria-hidden="true"
      [style.top.px]="box.top" [style.left.px]="box.left"
      [style.width.px]="box.width" [style.height.px]="box.height"></div>
  } @else if (mode() === 'centered') {
    <div class="guide__scrim" aria-hidden="true"></div>
  }

  <div #card class="guide__card" role="dialog" aria-modal="false" tabindex="-1"
    aria-labelledby="aria_guide_title" aria-describedby="aria_guide_body"
    [class.guide__card--hidden]="mode() === 'locating'"
    [style.top.px]="cardPosition()?.top" [style.left.px]="cardPosition()?.left">
    <button matIconButton type="button" class="guide__close" aria-label="Close tour"
      (click)="onClick_close()">
      <mat-icon>close</mat-icon>
    </button>
    <div aria-live="polite">
      <span class="cdk-visually-hidden">
        Step {{ index + 1 }} of {{ active.guide.steps.length }}
      </span>
      <h2 id="aria_guide_title" class="guide__title">{{ step.title }}</h2>
      <p id="aria_guide_body" class="guide__body">{{ step.body }}</p>
    </div>
    <div class="guide__footer">
      <ol class="guide__dots" aria-hidden="true">
        @for (item of active.guide.steps; track $index) {
          <li class="guide__dot" [class.guide__dot--active]="$index === index"></li>
        }
      </ol>
      <span class="guide__count" aria-hidden="true">
        {{ index + 1 }} of {{ active.guide.steps.length }}
      </span>
      <span class="guide__spacer"></span>
      @if (index > 0) {
        <button matButton type="button" (click)="onClick_back()">Back</button>
      }
      <button matButton="filled" type="button" (click)="onClick_next()">
        {{ isLast ? 'Done' : 'Next' }}
      </button>
    </div>
  </div>
}
